import React, { Component } from "react";
import "./header.scss";
import { getVersion, getEnv } from "../../../utils/buildinfo";
class Header extends Component {
  render() {
    return (
      <div className="header">
        <label className="version-header">{`v(${getVersion()})(${getEnv()})`}</label>
      </div>
    );
  }
}
export default Header;
